const en = {
  language: "English",

  menu: {
    home: "Home",
    service: "Service",
    cochain: "Co-Chain",
    developer: "Developer",
    team: "Team",
    message: "News",
    wallet: "Wallet",
    browser: "Explorer",
  },

  home: {
    slider1: {
      title: "SDChain",
      description:
        "Realizing the symbiosis and common prosperity of asset digitalization, chain and industrial Internet of Things",
    },
    slider2: {
      title: "SDChain",
      description:
        "Realizing the circulation and value conversion of credit digital assets",
    },
    slider3: {
      title: "SDChain",
      description:
        "Building a global benchmark for blockchain and IoT to promote the development of physical society",
    },
    part1: {
      title: "SixDomainChain",
      description:
        "The six-domain chain is the world's first decentralized public blockchain ecosystem that integrates the Internet of Things “six-domain model” international, Chinese national standards and distributed blockchain reference architecture standards. Fully consider the characteristics of the Internet of Things technology and the needs of commercial ecological construction, optimize on the existing basis to ensure the sustainable development of the six-domain chain business ecology, and realize the symbiosis and co-prosperity of asset digitalization, chain and industrial Internet of Things.",
      white: "White Paper",
    },
    part2: {
      head: "Advantages & Features",
      desc:
        "The self-developed blockchain bottom platform provides the international leading blockchain service",
      title1: "Safe and reliable",
      description1:
        "Asymmetric encryption algorithms and multiple security mechanisms ensure the security of digital assets and transactions across the six domain chains.",
      title2: "Running Stable",
      description2:
        "Nodes are distributed globally, and the node health monitoring system and fault tolerance mechanism ensure the stable operation of the blockchain basic services.",
      title3: "Excellent Performance",
      description3:
        "The self-developed SDFT consensus algorithm has high performance and short confirmation time, and can support high concurrent application scenarios.",
      title4: "Low Cost",
      description4:
        "The transaction rate is low, and only one ten-thousandth of the Gas in the chain can use the rich blockchain basic services on the six-domain chain.",
      title5: "Fully Functional",
      description5:
        "Support a variety of mainstream blockchain functions. Continuous development of new features to meet the needs of various blockchain application scenarios.",
      title6: "Convenient Access",
      description6:
        "Complete development documentation, API/SDK, and an active developer community to help you access the six domain chain in quickly.",
    },
    part3: {
      head: "Core Function",
      desc:
        "We focued on the development of the core technology of the blockchain",
      title1: "Asset Digitization",
      description1:
        "The SDChain supports the distribution of custom digital assets.Homogeneous and non-homogeneous digital assets can be distributed in one click. ",
      title2: "Data To Blockchain",
      description2:
        "The SDChain not only supports the general text, but also integrates IPFS to realize the storage of large files such as pictures, audio and video.",
      title3: "Smart Contract",
      description3:
        "The SDChain smart contract is written in LUA and is easy to learn. Contract deployment and execution are quick and easy, and the execution process can be tracked.",
    },
  },

  service: {
    slider1: {
      description:
        "Provide you with a complete industry solution based on blockchain",
    },
    part1: {
      head: "Service Content",
      desc:
        "Provide a full range of services from industry professional consulting to blockchain application development",
      title1: "Complete Solution",
      desc1:
        "Provide complete solutions for industry consulting, basic services, blockchain application design and development.",
      title2: "Basic Service Platform",
      desc2:
        "Provide blockchain basic services such as data chain storage and smart contracts.",
      title3: "Development Platform",
      desc3:
        "Help documentation, development tools, and technical support for six domain chain developers.",
    },
    part2: {
      head: "Basic Services",
      desc:
        "Abundant blockchain basic services to satisfy the needs of different application scenarios",
      title1: "Digital Asset Issuing",
      description1:
        "SDChain provides a one-click custom distribution of homogenized and non-homogeneous digital assets to satisfy the needs of virtual and physical asset digital scenarios.",
      title2: "Basic Service",
      description2:
        "The SDChain provides a blockchain service interface based on account generation, asset query, asset transfer, transaction history query, and data uplink.",
      title3: "Large File Service",
      description3:
        "SDChain integrates IPFS, which realizes the function of file chaining. Depending on the file size, you only need to support the corresponding GAS.",
      title4: "Smart Contract",
      description4:
        "The SDChain smart contract is written in LUA language and provides deployment, execution, and log query interfaces for interfacing with applications in easily.",
      title5: "Data Verification",
      description5:
        "The transaction information on the SDChain can be queried to meet the requirements of the user verification and confirmation chain transaction.",
      title6: "Asset Management",
      description6:
        "SDChain provides various types of wallet management tools to fully protect the security of digital assets on the chain through multiple security mechanisms. ",
    },
    part3: {
      head: "Service Status",
      desc: "Provide stable services to block chain customers all of the world",
      title1: "Service online time",
      title2: "Service is running",
      day: "days",
      title3: "Nodes amount",
      title4: "Block height",
      title5: "Total txAmount",
      btn1: "View Running Status",
    },
  },

  cochain: {
    slider1: {
      description:
        "Build a mature, proprietary blockchain platform at low cost and quickly",
      white: "Co-Chain White Paper",
    },
    part1: {
      head1: "Co-Chain Features",
      head2:
        "Build a mature, proprietary blockchain platform at low cost and quickly",

      title1: "Fast Construction",
      description1:
        "Omit the self-research cycle,just only take 3-5 days to build your own blockchain platform.",
      title2: "Low Cost",
      description2:
        "The R&D investment is omitted and the blockchain service can be used with little gas.",
      title3: "Multi Function",
      description3:
        "The perfect blockchain basic function satisfies the need for blockchain services without application scenarios.",
      title4: "Mature Platform",
      description4:
        "Based on the technology of the SDChain, the platform is mature and technical services are guaranteed.",
      title5: "Service Profession",
      description5:
        "The full-time team participates in the Co-Chain construction and solves various problems at any time.",
      title6: "Abundant Resources",
      description6:
        "Seamlessly connect with other Co-Chain ecosystems, interconnect and develop together.",
    },
    part2: {
      head1: "Co-Chain Kits & Services",
      head2: "Provide with a full service from scratch to build blockchain",
      title1: "Service Platform",
      description1:
        "A separate API that serves the application of this Co-Chain ecosystem.",
      title2: "Basic Application ",
      description2:
        "Issuing your assets in distribution platform, block browser and wallet app.",
      title3: "Training Services",
      description3:
        "Basic knowledge, methods of use, daily maintenance training, experience and case sharing.",
      title4: "Technical Services",
      description4:
        "The professional implementation team participates in the construction of the blockchain infrastructure.",
      title5: "Consulting Service",
      description5:
        "Provide blockchain integration consulting services for Co-Chain Ecology.",
      title6: "Underlying Platform",
      description6: "A separate node that serves the Co-Chain ecosystem.",
    },
    part3: {
      head1: "Co-Chain Rating",
      head2: "Different types of services for different grades of Co-Chain",
      title1: "Enterprise Co-Chain",
      description1:
        "Mainly for enterprise-level application projects and early incubation projects with on-line and pass-through requirements. Enjoy the blockchain usage rights of Co-Chain.",
      title2: "Advanced Co-Chain",
      description2:
        "Applicants generally require a relatively rich ecological resources and business cooperation resources, as well as good blockchain community operation development experience and social credibility.",
      title3: "Super Co-Chain",
      description3:
        "On the basis of the advanced Co-Chain, the Co-Chain underlying blockchain base platform with autonomy rights and interests enjoys the rights to participate in major decision-making discussions in the SDChain community.",
      btn1: "Apply ",
    },
  },

  developer: {
    part1: {
      head1: "Developer ",
      head2: "One-step for blockchain app developers",
      btn1: "Become A Developer",
    },
    part2: {
      head: "Developer Started",
      head2:
        "For the beginner to use the six-domain chain for DApp development",
      text1:
        "The developer platform will introduce you to the technical characteristics of SDChain and the node building method to help you quickly understand and access SDChain.",
      foot1: "Learn The Platform",
      text2:
        "To become a SDChain developer, you can also get the corresponding development incentives for the use of SDChain test environment blockchain basic services.",
      foot2: "Become  Developer",
      text3:
        "A tutorial is used to create and activate a SDChain account, and a SDChain of native assets is used to do a transaction on blockchain.",
      foot3: "Tutorial",
    },
    part3: {
      head: "Developer Support",
      head1:
        "Provide the most comprehensive technical support for you with SDChain",
      title1: "Guide",
      description1: "Quick Start",
      description2: "Explanation",
      description3: "SDChain Core",
      description4: "Smart Contract",
      description11: "",
      description12: "Common Errors",
      title3: "Resource",
      description21: "Service",
      description22: "Community",
      description23: "SD-Holographic",
    },
  },

  applyDeveloper: {
    head: "Developer Application",
    name: "Name",
    nameTip: "Please enter your name",
    man: "Mr.",
    woman: "Mrs.",
    country: "Country",
    countryTip: "Please select your country",
    city: "City",
    cityTip: "Please enter your city",
    identity: "Your Identity",
    company: "Company",
    person: "Personal",
    companyName: "Company Name",
    companyNameTip: "Please enter Company Name",
    companyAddress: "Company Address",
    companyAddressTip: "Please enter Company Address",
    email: "E-mail",
    emailTip: "Plase enter your email",
    eamilRepeat: "Email has already been used",
    emailValid: "The mailbox format is incorrect",
    emailCode: "E-mail Code",
    emailCodeTip: "piease enter the email veriicanouase code",
    emailCodeSuccess: "Sent successfully",
    getCode: "Get Code",
    description: "Programming Language Used",
    descriptionTip: "Please enter the programing language used",
    apply: "Apply",
    tip:
      "Application result will be notified by email within 1-3 business days.",
    successtitle: "Submitted successfully",
    confirm: "Confirm",
  },

  team: {
    head: "Team",
    desc:
      "SDChain composed of international blockchain and IoT industry experts",
    part1: {
      head: "Decision Committee",
      title1: "Jie Shen",
      description1:
        'Jie obtained Ph.D from Chinese Academy of Sciences after receiving bachelor degree from Zhejiang University, and was visiting scholar at University of California at San Diego (UCSD). He is an international authoritative experts in IoT, with 15 Years of IoT experience and 3 Years of blockchain research experience, and participated in developing the worlds first international Internet of Things Reference Architecture (IoT RA) ISO / IEC 30141 on behalf of Chinese Leaders. He is also the proposer and chief editor of the "Six-Domain Model" of IoT, sponsor of Joint Laboratory for Six-Domain Blockchain, founder of Qingyu Tang, and part-time professor of Fudan University. Since 2011, he has been the general team leader of the National IoT Basic Standard Working Team and promoted development of dozens of basic standards and application standards for Internet of Things jointly with the Ministry of Public Security, Ministry of Agriculture, Ministry of Transport, Ministry of Environmental Protection, State Forestry Administration, National Health and Family Planning Commission and China National Textile and Apparel Council. He was once the vice president of Wuxi Internet of Things Industry Research Institute, vice director of National Research Center for Sensor Network Engineering Technology of Ministry of Science and Technology, and vice chairman of the CCSA TC10. He has presided over 10+ state-level scientific research projects related to IoT and 10+ international and national standards, and was awarded the first prize of Shanghai Science and Technology Advances, the second prize of China Standard Innovation and the Advanced Individual of the National Information Security Standardization Technical Committee.',
      title2: "David Pan",
      description2:
        "David joined SDChain with 20 years of industry experience serving North American and Asian technology and investment companies in IoT, semiconductor, software, electronics manufacturing and telecom sectors. Prior to SDChain, David served as the Director of IoT Asia Marketing at Arm, growing and supporting Arm’s IoT developer ecosystem and partnerships in Asia. Prior to Arm, David served as the President of Ayaris 9 with sell-side mandates in IoT, clean tech and e-commerce sectors, as well as managing buy-side venture capital specialised in pre-IPO projects. David graduated from Harvard with a Masters in Finance, Golden Gate with Masters in Enterprise Systems, and UC Berkeley with BA in Architecture.",
      title3: "Richard Zhou",
      description3:
        "Richard is currently the President of Green Panda Marketing Inc. in Toronto, Canada, Advisor to multiple Fortune 500 companies and Nasdaq-listed companies, and Advisor to China Canada Angel Alliance. Formerly, Richard served as an Independent Board Director of Internet of Things Inc. (TSX.v-ITT), Assistant Director of Ontario Ministry of Tourism, Culture and Sports, Canada, Co-Chair of TIFF China Internet Film and Television Development Forum, President of Canada Evergreen Association, and Founding Director of Chinese Cabinet of Toronto Sick Kids Foundation, one of the largest charity organizations in Canada. Richard has 20 years of industry experience in information technology, Internet, IoT, Energy, serving at EMC, Siemens, and Apotex.",
    },
    part2: {
      head: "Team Consultant",
      title1: "Lirong Zheng",
      description1:
        'Lirong is a professor of Royal Institute of Technology, Sweden, Dean of School of Information Science and Technology, Fudan University, Executive Vice President of New Rural Development Institute, Fudan University and Distinguished Professor of China’s National "Thousand Talents Program".',
      title2: "Eduard Molla",
      description2: "Eduard is Economic Counselor of Albania in China.",
      title3: "Qiang Yin",
      description3:
        "Qiang holds EMBA from Donghua University, Vice President of Circulation Branch of China National Textile And Apparel Council, Deputy Director of IoT standard working group for textile industry, and GM of CNTEX.",
      title4: "XuMing He",
      description4:
        "Xuming is the Chairman of Organizing Committee of World Internet of Things Convention, Chairman of World Chinese Business Alliance Federation, President of World Chinese Entrepreneurs Alliance Group, Executive Chairman of Chinese Entrepreneurs Alliance, Chairman of Warner Fund (Beijing), Chairman of World Chinese Business Alliance Investment Fund Management Company, and formerly served as Executive Officer of Chinese Chamber of Commerce in China, CEO of Warner Investment Group (US), Executive Officer of Promotion Association of Chinese Chamber of Commerce, and Executive Secretary General of Chinese Business Alliance Federation.",
      title5: "BinXian Liang",
      description5:
        "Binxian is the Chairman of Taiwan Internet of Things Alliance, Chairman and GM of Flowring, Dean of the Cross-Strait Intelligence Service Industry Institute of Nanjing University of Posts and Telecommunications, Vice Chairman of IOTCC, China Electronics Chamber of Commerce, MIIT, Executive Chairman of Alliance of Sensing China, Executive Director of Jiangsu Innovation Center for Internet of Things Technology and Application Synergy, Vice Chairman of Zhejiang Technology Innovation Association for Automotive Industry, Vice Chairman of Wuxi Cross-Strait Technology and Financial Services Center, Member of Technical Expert Committee of Cloud Computing and IoT Association in Taiwan (CIAT), and Member of Cloud Computing and IoT Committee of Taiwan Electrical and Electronic Manufacturers Association.",
    },
    part3: {
      head: "Core Technology Team",
      title2: "Faud a.Khan",
      description2:
        "Apart from his leadership role at SDChain, Faud is the Chair of Canada International Organization for Standardization (ISO / IEC SC27), Convenor of IOT Special Working Group, International Convener of ISO / IEC SC41, CEO and Security Analyst of TwelveDot Labs, delivering network security solutions to customers worldwide. He has over 21 years experience in cybersecurity industry.",
      title3: "Yue Gao",
      description3:
        "Apart from his leadership role at SDChain, Yue Gao is a Reader in Antennas and Signal Processing, and Director of Whitespace Machine Communication (WMC) Lab in the School of Electronic Engineering and Computer Science at at Queen Mary University of London (QMUL). He worked as Research Assistant, Lecturer (Assistant Professor) and Senior Lecturer (Associate Professor) at QMUL after his PhD degrees from QMUL in 2007. He is currently leading a team developing theoretical research into practice in the interdisciplinary area among smart antennas, signal processing, spectrum sharing and internet of things (IoT) applications. He has published over 120 peer-reviewed journal and conference papers, 2 patents, and 2 book chapters. He is a co-recipient of the EU Horizon Prize Award on Collaborative Spectrum Sharing in 2016, and Research Performance Award from Faulty of Science and Engineering at QMUL in 2017. He is an Editor for the IEEE Transactions on Vehicular Technology, IEEE Wireless Communication Letter and China Communications. He is serving as Cognitive Radio Symposium Co-Chair of the IEEE GLOBECOM 2017. He has served as the Signal Processing for Communications Symposium Co-Chair for IEEE ICCC 2016, Publicity Co-Chair for IEEE GLOBECOM 2016, and General Chair of the IEEE WoWMoM and iWEM 2017. He is a Senior Member of IEEE, a Secretary of the IEEE Technical Committee on Cognitive Networks, and an IEEE Vehicular Technology Society Distinguished Lecturer.",
      title4: "WenBo Xu",
      description4:
        'Wenbo holds Master of Software Engineering from Fudan University, with 8 years of experience in C + + server-side software development and architecture design and 4 years of experience in R&D team management. Wenbo was responsible for the development of Shanghai Telecom "Game Frontier" platform, precision location-based services (PC LBS), Internet users portrait and data mining, centralized batch stamp inspection for Bank of Suzhou and electronic stamp inspection for other banks. Recently, he has led the blockchain module package development on Arm mbed OS. Wenbo has valuable blockchain IoT project development and implementation experience, and rich software security system development capabilities.',
    },
  },

  message: {
    slider1: {
      title: "News",
      description: "Provide you with the latest sdchain news and development",
    },
    part2: {
      tab1: "Weekly Project",
      tab2: "Media Reports",
      tab3: "Growing History",
      tab4: "Announcement",
    },
  },

  messageDetail: {
    position: "Path",
    news: "News",
    notice: "Announcement",
    weekly: "Weekly Project",
    report: "Media Reports",
    itemdate: "Released time：",
  },
  history: {
    icon1: "12",
    text1: "Development of ecological application based on SDChain",
    icon2: "8",
    text2:
      "The official version of the main network released, and the SDA of ERC-20 and SDChain is carried out at the same time",
    icon3: "6",
    text3:
      "Increase 2000~5000 tps, complete the layering, cross-chain development",
    icon4: "5",
    text4:
      "Publish the iOS version of the wallet for beta testing and release the first application based on SDChain",
    icon5: "3/31",
    text5:
      "Publish the Android version of the wallet for beta testing and the browser based on SDChain",
    icon6: "3/13",
    text6:
      "The beta version of SDChain network is launched, and community members are invited to participate in test group",
    icon7: "10",
    text7: "SDChain completed the development of the base layer and core layer",
    icon8: "5",
    text8: "Six-domain chain (SDChain) project started",
  },

  wallet: {
    slider1: {
      tit: "SD-Wallet",
      downapp: "Download App",
      description: "SDChain digital asset security management experts",
      login: "Wallet(Web) Login",
    },
    part1: {
      head: "Wallet Features",
      head2: "Protect digital assets in all domains",
      title1: "Safe & Reliable",
      description1:
        "Keep your own keys and multiple security mechanisms to secure your digital assets and transactions.",
      title2: "Real & Effective",
      description2:
        "Based on SDChain, all of transactions can be traced and cannot be modified.",
      title3: "High Performance",
      description3: "The query and transaction of digital assets is fast.",
      title4: "Used easily",
      description4:
        "SDChain provided multiple version with a simple interface and operability.",
    },
    part2: {
      head: "Features",
      head2: "A full-featured digital asset management tool",
      title1: "Wallet Management",
      description1:
        "Support key management and backup of multiple wallets, and a variety of security mechanisms to protect your wallet security.",
      title2: "Asset Management",
      description2:
        "Query and trade real digital assets on SDChain to help you manage your personal digital assets.",
      title3: "News",
      description3:
        "The latest blockchain industry information to help you understand the latest industry trends.",
      title4: "Asset Trading",
      description4:
        "SD-Wallet decentralized digital asset trading center will be launched soon, so stay tuned...",
    },
  },

  common: {
    footer: "CopyRight © 2017-2019 SDChain Alliance, Toronto, Canada",
    loadMore: "Load More",
    // download: '下载',
    // timeOut: '请求超时,请重试',
  },
  download: {
    down: "Download",
  },
  extension: {
    head1: "SDWalletPay User Guide",
    head2: "SDWalletPay Download",
    title1: "1、 Installation of SDWalletPay",
    text1:
      "1. Installation of the SDWalletPay, click on this page",
    link1: "SDWalletPay Download",
    text2:
      "Button, download the latest SDWalletPay installation package",
    text3: "Decompress the downloaded compressed file",
    text4: "Download Google Chrome browser",
    text5: "After downloading, install Chrome browser",
    text6:
      "Open Chrome browser and click on 'Extensions' in the upper right corner, then click on 'Manage Extensions'",
    text7: "Enable developer mode",
    text8:
      "Click on 'Load unpacked' and then select the previously extracted toolkit folder",
    text9:
      "After successful addition, click on the 'Extensions' icon in the upper right corner of the Chrome browser. Select 'SDwalletPay' to open the SDWalletPay",
  },
};

export default en;
